// public/js/modules/adminState.js
let _isAdmin = false;

export function isAdmin() {
  return _isAdmin;
}

export function setIsAdmin(status) {
  _isAdmin = !!status;
}